module.exports = __webpack_public_path__ + "assets/img/image-wide.b20049c6.jpg";